var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "back_simple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1423 -9)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3697",
    width: 32,
    height: 32,
    rx: 16,
    transform: "translate(1423 9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(1431 13)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1439 33-8-8 8-8 1.425 1.4-5.6 5.6H1447v2h-12.175l5.6 5.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackSimple);
export default __webpack_public_path__ + "static/media/back_simple.fc5f5b0923c855ebc0bad4b2007789b7.svg";
export { ForwardRef as ReactComponent };